const initCityAutocomplete = () => {
  const container = document.querySelector('[data-city-autocomplete]');

  if (!container) {
    return;
  }

  const input = container.querySelector('[data-city-input]');
  const cityCode = container.querySelector('[data-city-code]');
  const dropdown = container.querySelector('[data-city-dropdown]');

  if (!input || !cityCode || !dropdown) {
    return;
  }

  let timeout;
  let controller;

  const hideDropdown = () => {
    dropdown.hidden = true;
    dropdown.innerHTML = '';
  };

  const selectCity = (city) => {
    const cityName = city.full_name.split(',')[0].trim();

    input.value = cityName;
    cityCode.value = city.code;

    hideDropdown();

    jQuery(document.body).trigger('update_checkout');
  };

  const renderCities = (cities) => {
    dropdown.innerHTML = '';

    if (!cities.length) {
      hideDropdown();
      return;
    }

    cities.forEach((city) => {
      const button = document.createElement('button');

      button.type = 'button';
      button.className = 'custom-input__option';
      button.textContent = city.full_name;

      button.addEventListener('click', () => {
        selectCity(city);
      });

      dropdown.append(button);
    });

    dropdown.hidden = false;
  };

  const loadCities = async (query) => {
    controller?.abort();
    controller = new AbortController();

    const body = new URLSearchParams({
      action: 'cdek_city_suggest',
      nonce: wooSettings.cdekCityNonce,
      query,
    });

    try {
      const response = await fetch(wooSettings.ajaxUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
        credentials: 'same-origin',
        body,
        signal: controller.signal,
      });

      const result = await response.json();

      if (!result.success) {
        hideDropdown();
        return;
      }

      renderCities(result.data);
    } catch (error) {
      if (error.name !== 'AbortError') {
        hideDropdown();
      }
    }
  };

  input.addEventListener('input', () => {
    clearTimeout(timeout);

    cityCode.value = '';

    const query = input.value.trim();

    if (query.length < 2) {
      hideDropdown();
      return;
    }

    timeout = setTimeout(() => {
      loadCities(query);
    }, 300);
  });

  document.addEventListener('click', (event) => {
    if (!container.contains(event.target)) {
      hideDropdown();
    }
  });
};

export {initCityAutocomplete};